import { render, staticRenderFns } from "./BlogArticleHeader.vue?vue&type=template&id=cbe8a28e&"
import script from "./BlogArticleHeader.vue?vue&type=script&lang=js&"
export * from "./BlogArticleHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports